<template>
  <div class="single-article-card container-fluid">
    <div class="row av" v-if="isLoaded && dispMounted">
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-12 p-0">
            <input
              :id="chiave"
              type="checkbox"
              :disabled="!priceFound"
              @change="articleSelection"/>
            <span class="cod_art">{{ cod_art }}</span>
          </div>

          <div class="d-flex w-100 prezzi">
            <div class="col-md-12 d-flex is-justify-content-space-between p-0">
              <price-elm v-if="cod_art && currentUser" :cod_art="cod_art" :unita_misura="unita_misura" :current_user="currentUser" @prezzi="fetchPrezzi" @unita-misura="fetchUnitaMisura"/>
<!--              <ul v-for="sc in prezzi">-->
<!--                <li v-if="prezzi">-->
<!--                  {{-->
<!--                    sc.prezzoNetto.toLocaleString("it-IT", {-->
<!--                      minimumFractionDigits: 2,-->
<!--                    })-->
<!--                  }}-->
<!--                  {{ trans.get("b2b.article.price") }}-->
<!--                </li>-->
<!--              </ul>-->
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <p
          :class="
            disponibilita > 0
              ? 'disponibilita available'
              : 'disponibilita unavailable'
          "
          v-if="dispMounted"
        >
          <img
            :src="
              disponibilita > 0
                ? url('/media/icons/available.svg')
                : url('/media/icons/unavailable.svg')
            "
            :alt="disponibilita"
          />
          <span>{{ trans.get("b2b.article.availability") }} {{ disponibilita }} {{ unitaMisuraLong }}</span>

        </p>
        <p class="quantita">{{ trans.get("b2b.article.quantity") }}</p>
        <b-field>
          <b-numberinput
            :step="qtaimballo === 0 ? 1 : qtaimballo"
            type="is-dark"
            :min="qtaimballo"
            v-model="quantita"
            :disabled="!priceFound"
            controls-position="compact"
            size="is-small"
          />
        </b-field>
      </div>
      <div class="col-md-2">
        <p>{{ trans.get("b2b.cart.total") }}</p>
        <p v-if="priceFound">
          {{prezzoTotale.toLocaleString("it-IT", { minimumFractionDigits: 3 }) }} €
        </p>
      </div>
    </div>
    <b-skeleton size="is-large" height="50px" :active="!isLoaded && !dispMounted"></b-skeleton>
  </div>
</template>

<script>
export default {
  name: "av-card",
  props: ["cod_art", "qtaimballo", "chiave", "unita_misura"],
  data: function () {
    return {
      isLoaded: false,
      disponibilita: null,
      dispMounted: false,
      prezzoTotale: null,
      quantita: this.qtaimballo,
      // currentUser: null,
      // currentRole: null,
      prezzi: [],
      priceFound: false,
      unitaMisura: null,
      unitaMisuraLong: null,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
  mounted() {
    //this.getCurrentUser();
    this.getGiacenza(this.cod_art);
  },
  watch: {
    quantita: function () {
      let prezzo = this.prezzi[0].prezzoNetto
      if (this.prezzi.length > 1){
        length = this.prezzi.length
        if (this.quantita < this.prezzi[length - 2].qta){ // < 99
          prezzo = this.prezzi[0].prezzoNetto
        } else if (this.quantita >= this.prezzi[length - 2].qta && this.quantita < this.prezzi[length - 1].qta){ // >= 100 < 499
          prezzo = this.prezzi[1].prezzoNetto
        } else if (this.quantita >= this.prezzi[length - 1].qta ){ // >= 500
          prezzo = this.prezzi[2].prezzoNetto
        }
      }
      this.prezzoTotale = this.quantita * prezzo;
      let checkbox = $("#" + this.chiave);
      checkbox.prop("checked", true);
      this.articleSelection();
    },
  },
  methods: {
    fetchUnitaMisura(values){
      this.unitaMisura = values
      if (this.unitaMisura === 'Mt'){
        this.unitaMisuraLong = this.$trans('b2b.prices.meters')
      }else {
        this.unitaMisuraLong = this.$trans('b2b.prices.pieces')
      }
    },
    fetchPrezzi(values){
      //console.log(values)
      this.priceFound = values.priceFound
      if (values.scaglioni !== null) {
        this.prezzi = values.scaglioni
        let prezzo = this.prezzi[0].prezzoNetto
        if (this.prezzi.length > 1){
          length = this.prezzi.length
          if (this.quantita < this.prezzi[length - 2].qta){ // < 99
            prezzo = this.prezzi[0].prezzoNetto
          } else if (this.quantita >= this.prezzi[length - 2].qta && this.quantita < this.prezzi[length - 1].qta){ // >= 100 < 499
            prezzo = this.prezzi[1].prezzoNetto
          } else if (this.quantita >= this.prezzi[length - 1].qta ){ // >= 500
            prezzo = this.prezzi[2].prezzoNetto
          }
        }
        this.prezzoTotale = this.quantita * prezzo
      }
    },
    getCurrentUser: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-current-user",
      })
        .then((res) => {
          //console.log(res.data)
          this.currentUser = res.data.user;
          this.currentRole = res.data.role;

          //this.getPrices(this.cod_art, this.currentUser);
        })
        .catch((err) => {
          this.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        });
    },

    getPrices: function (codart, user) {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/prezzi",
        params: {
          codart: codart,
          codcliente: user,
        },
      })
        .then((res) => {
          //console.log(res.data[0].scaglioni.length)
          if (res.data[0].scaglioni.length !== 0) {
            this.prezzi = res.data[0].scaglioni;
          } else {
            //console.log('default')
            this.prezzi.push({
              prezzoNetto: parseFloat("1"),
            });
          }
          this.prezzoTotale = this.quantita * this.prezzi[0].prezzoNetto
          this.isLoaded =  true
          this.dispMounted =  true
        })
        .catch((err) => {
          this.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        });
    },
    articleSelection: function () {
      let checkbox = $("#" + this.chiave);

      let prezzo = this.prezzi[0].prezzoNetto
      if (this.prezzi.length > 1) {
        length = this.prezzi.length
        if (this.currentQuantita < this.prezzi[length - 2].qta) { // < 99
          prezzo = this.prezzi[0].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 2].qta && this.currentQuantita < this.prezzi[length - 1].qta) { // >= 100 < 499
          prezzo = this.prezzi[1].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 1].qta) { // >= 500
          prezzo = this.prezzi[2].prezzoNetto
        }
      }

      if (checkbox.prop("checked")) {
        this.$emit("forCart", {
          key: this.chiave,
          selected: true,
          articolo: this.cod_art,
          quantita: this.quantita,
          prezzo: this.quantita * prezzo,
          prezzo_unitario: prezzo,
        });
      } else {
        this.$emit("forCart", {
          key: this.chiave,
          selected: false,
          articolo: this.cod_art,
          quantita: this.quantita,
          prezzo: this.quantita * prezzo,
        });
      }
    },
    getGiacenza: function (codart) {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/giacenze",
        params: {
          codart: codart,
        },
      })
        .then((res) => {
          this.disponibilita = res.data[0].disponibilita;
          this.isLoaded =  true
          this.dispMounted =  true

        })
        .catch((err) => {
          this.$store.commit("add_message", {
            type: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.single-article-card {

  .row.av{
    margin: 0 15px;
  }
  color: #26262a;
  background-color: #f5f5f5;
  padding-left: 15px;
  padding-bottom: 15px;
  padding-top: 7px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d8d8d8;
  &.disabilitato {
    color: #8d8d8d;
  }
  .cod_art {
    font-size: 15px;
    margin-left: 20px;
  }

  input {
    transform: scale(1.2);
  }

  .prezzi {
    margin-top: 20px;
    font-size: 12px;
  }

  .quantita {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .disponibilita {
    img {
      display: inline-block;
      margin-right: 12px;
    }

    &.available {
      color: #23b371;
    }

    &.unavailable {
      color: #b32323;
    }
  }
}
</style>
